export default {
  FETCH_ACTIONS_REQUEST: "FETCH_ACTIONS_REQUEST",
  FETCH_ACTIONS_FAILED: "FETCH_ACTIONS_FAILED",
  FETCH_ACTIONS_SUCCESS: "FETCH_ACTIONS_SUCCESS",

  ADD_ACTION_REQUEST: "ADD_ACTION_REQUEST",
  ADD_ACTION_FAILED: "ADD_ACTION_FAILED",
  ADD_ACTION_SUCCESS: "ADD_ACTION_SUCCESS",

  UPDATE_ACTION_REQUEST: "UPDATE_ACTION_REQUEST",
  UPDATE_ACTION_FAILED: "UPDATE_ACTION_FAILED",
  UPDATE_ACTION_SUCCESS: "UPDATE_ACTION_SUCCESS",

  DELETE_ACTION_REQUEST: "DELETE_ACTION_REQUEST",
  DELETE_ACTION_FAILED: "DELETE_ACTION_FAILED",
  DELETE_ACTION_SUCCESS: "DELETE_ACTION_SUCCESS"
};
